module.exports = __webpack_public_path__ + "static/media/shape-1.f26f4c44.svg";